/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Role_MentorInputs */

const en_cp_role_mentor = /** @type {(inputs: Cp_Role_MentorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mentor / practitioner / alumni`)
};

const id_cp_role_mentor = /** @type {(inputs: Cp_Role_MentorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mentor / praktisi / alumni`)
};

/**
* | output |
* | --- |
* | "Mentor / practitioner / alumni" |
*
* @param {Cp_Role_MentorInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_role_mentor = /** @type {((inputs?: Cp_Role_MentorInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Role_MentorInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_role_mentor(inputs)
	return en_cp_role_mentor(inputs)
});